
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import ClientsidePaging from "@/components/ClientsidePaging";
import { ApplicationState, SeafarerApplicationLightViewModel} from "@/api-client";
import {formatDate} from "@/formatting/dateFormatter";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import translateApplicationState from "@/features/applications/components/ApplicationStateTranslator";
import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
import ApplicationStateBadge from "@/features/applications/components/ApplicationStateBadge.vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";

@Component({
    components: {
        CardQuicklink,
        ApplicationStateBadge,
        TableEmptySlot
    }
})
export default class SeafarerDashboardApplicationTable extends Vue {
    @Prop({required: true})
    applications!: SeafarerApplicationLightViewModel[];

    @Prop({required: false, default: 'dateSubmitted'})
    sortBy!: string | null

    @Prop({required: false, default: false})
    sortDesc!: boolean

    @Prop({required: false, default: () => new ClientsidePaging()})
    paging!: ClientsidePaging;

    applicationFields = [
        {key: 'documentNumber', label: this.$ls.Dashboard_Seafarer_Table_Label_DocumentNumber, sortable: true, thClass: 'w-10'},
        {key: 'certificateName', label: this.$ls.Global_Label_CertificateTypeName, sortable: true, tdClass: 'certificate-name'},
        {key: 'documentType', label: this.$ls.Global_Label_DocumentTypeShort, sortable: true, thClass: 'w-10'},
        {
            key: 'dateSubmitted',
            label: this.$ls.Dashboard_Seafarer_Table_Label_DateSubmitted,
            sortable: true,
            thClass: 'w-15',
            formatter: (value: any, key: any, item: SeafarerApplicationLightViewModel) => formatDate(item.dateSubmitted)
        },
        {
            key: 'hasDocumentDeliveryBeenConfirmed',
            label: this.$ls.Dashboard_Seafarer_Table_Label_IsDeliveryConfirmed,
            thClass: 'w-15',
            formatter: (value: any, key: any, item: SeafarerApplicationLightViewModel): string => translateTrueFalse(item.hasDocumentDeliveryBeenConfirmed)
        },
        {
            key: 'state',
            label: this.$ls.Dashboard_Seafarer_Table_Label_ApplicationState,
            sortable: true,
            sortByFormatted: true,
            thClass: 'w-20',
            formatter: (state: ApplicationState): string => translateApplicationState(state)
        },
        {key: 'linkIcon', label: '', sortable: false, tdClass: 'table-actions'}
    ];

    navigateToApplicationOverview(application: SeafarerApplicationLightViewModel) {
        this.$router.push({name: "ApplicationOverview", params: {applicationId: application.id}});
    }
}
